module.exports = __webpack_public_path__ + "img/per-ride.730ace71.svg";